export const getFundAsGiftProject = (state, fundAsGiftCode) => {
    if (state.fundAsGift.fundAsGiftProject?.fundAsGiftCode === fundAsGiftCode) {
        return state.fundAsGift.fundAsGiftProject;
    }
    return undefined;
};

export const getFundAsGiftFetchingStatus = (state) => {
    return state.fundAsGift.isFetching;
};

export const getFundAsGiftError = (state) => {
    return state.fundAsGift.error;
};

export const getFundAsGiftProjectNotCreatedStatus = (state) => {
    return state.fundAsGift.fundAsGiftProjectNotCreated;
};
